/**
 * Minimal RFC 4180 serializer. A value is quoted only when it has to be — a comma, quote, or line
 * break inside it — and inner quotes are doubled. Emails and ISO dates come out unquoted.
 */
const escapeCell = (value: string): string => (
  /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value
);

export const toCsv = (header: string[], rows: string[][]): string => (
  [header, ...rows].map((row) => row.map(escapeCell).join(',')).join('\r\n') + '\r\n'
);
